import React from 'react';
import Carte from '../ui/Carte';
import ChampTexte from '../champs/ChampTexte';
import ChampGenre from '../champs/ChampGenre';

function SectionClient({ donnees, onChange }) {
  return (
    <>
      <Carte titre="Client" icone="👤">
        <div className="grille grille--2col">
          <ChampGenre
            valeur={donnees.genre}
            onChange={onChange}
            nom="genre"
          />
          <ChampTexte
            label="Fonction"
            valeur={donnees.fonction}
            onChange={onChange}
            nom="fonction"
            placeholder="ex : Directeur Général"
          />
          <ChampTexte
            label="Prénom"
            valeur={donnees.prenom}
            onChange={onChange}
            nom="prenom"
            placeholder="Jean"
          />
          <ChampTexte
            label="Nom"
            valeur={donnees.nom}
            onChange={onChange}
            nom="nom"
            placeholder="Dupont"
          />
          <ChampTexte
            label="Mail"
            valeur={donnees.mail}
            onChange={onChange}
            nom="mail"
            placeholder="ex : jean.dupont@mail.com"
            typeMail
          />
        </div>
      </Carte>

      <Carte titre="Entreprise" icone="🏢">
        <div className="grille grille--2col">
          <ChampTexte
            label="Raison sociale"
            valeur={donnees.nomEntreprise}
            onChange={onChange}
            nom="nomEntreprise"
            placeholder="Acme SAS"
          />
          <ChampTexte
            label="SIRET"
            valeur={donnees.siret}
            onChange={onChange}
            nom="siret"
            placeholder="14 chiffres"
            maxLength={14}
            chiffresUniquement
            typeSiret
          />
          <ChampTexte
            label="Adresse"
            valeur={donnees.adresse}
            onChange={onChange}
            nom="adresse"
            placeholder="12 rue de la Paix, 75001 Paris"
            pleineLargeur
          />
        </div>
      </Carte>
    </>
  );
}

export default SectionClient;
